import React from 'react';
import { CheckCircle, Clock, FileText, AlertCircle, BookOpen, LucideIcon } from 'lucide-react';
import clsx from 'clsx';
import { ContractStatus } from '../../types/contract'; // Import ContractStatus

interface ContractStatusPillProps {
  status: ContractStatus; // Use the imported ContractStatus type
}

const statusMap: Record<ContractStatus, { label: string; icon: LucideIcon; colors: string }> = {
  accepted: {
    label: 'Accepted',
    icon: CheckCircle,
    colors: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
  },
  pending: {
    label: 'Pending',
    icon: Clock,
    colors: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300',
  },
  draft: {
    label: 'Draft',
    icon: FileText,
    colors: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
  },
  rejected: {
    label: 'Rejected',
    icon: AlertCircle,
    colors: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
  },
  published: {
    label: 'Published',
    icon: BookOpen,
    colors: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
  },
};

const ContractStatusPill: React.FC<ContractStatusPillProps> = ({ status }) => {
  const { label, icon: Icon, colors } = statusMap[status];

  return (
    <span
      className={clsx(
        'inline-flex items-center px-3 py-1 rounded-full text-sm font-medium',
        colors
      )}
    >
      <Icon className="h-4 w-4 mr-2" />
      {label}
    </span>
  );
};

export default ContractStatusPill;
